export default "__VITE_ASSET__Qrjo_l$y__"